import * as i0 from '@angular/core';
import { Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class E11IndicatorComponent {
    constructor() {
        this.color = 'primary-accent';
        this.size = 'xs'; // || 'square'
        this.posAdjustY = '';
        this.posAdjustX = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11IndicatorComponent, selector: "e11-indicator", inputs: { color: "color", size: "size", classOverrides: "classOverrides", posAdjustY: "posAdjustY", posAdjustX: "posAdjustX" }, ngImport: i0, template: "<div class=\"e11-indicator-container\">\n  <div\n    class=\"e11-indicator e11-absolute e11-bg-skin-{{ color }} e11-indicator-size-{{ size }}\"\n    style=\"left: {{ posAdjustX }}; top: {{ posAdjustY }}\"\n  ></div>\n</div>\n", styles: [".e11-indicator{display:flex;border-radius:50%;position:absolute}.e11-indicator.e11-indicator-size-xs{height:6px;min-width:6px}.e11-indicator.e11-indicator-size-sm{height:10px;min-width:10px}.e11-indicator.e11-indicator-size-md{height:14px;min-width:14px}.e11-indicator.e11-indicator-size-lg{height:18px;min-width:18px}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-indicator', encapsulation: ViewEncapsulation.None, template: "<div class=\"e11-indicator-container\">\n  <div\n    class=\"e11-indicator e11-absolute e11-bg-skin-{{ color }} e11-indicator-size-{{ size }}\"\n    style=\"left: {{ posAdjustX }}; top: {{ posAdjustY }}\"\n  ></div>\n</div>\n", styles: [".e11-indicator{display:flex;border-radius:50%;position:absolute}.e11-indicator.e11-indicator-size-xs{height:6px;min-width:6px}.e11-indicator.e11-indicator-size-sm{height:10px;min-width:10px}.e11-indicator.e11-indicator-size-md{height:14px;min-width:14px}.e11-indicator.e11-indicator-size-lg{height:18px;min-width:18px}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }], size: [{
                type: Input
            }], classOverrides: [{
                type: Input
            }], posAdjustY: [{
                type: Input
            }], posAdjustX: [{
                type: Input
            }] } });

class E11IndicatorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11IndicatorModule, declarations: [E11IndicatorComponent], imports: [CommonModule], exports: [E11IndicatorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IndicatorModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11IndicatorComponent],
                    imports: [CommonModule],
                    exports: [E11IndicatorComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11IndicatorComponent, E11IndicatorModule };
